module.exports = __webpack_public_path__ + "static/nerpa_loading-9e3763fe67f4aa1b987117553666ff6e.gif";